import React from 'react'
import { Link } from 'react-router-dom'
import { Shield, ArrowLeft } from 'lucide-react'
import PrivacyContent from '@/content/legal/PrivacyContent'

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">

        <div className="mb-8 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
          <div className="flex items-center gap-2 text-gray-400 text-sm">
            <img
              src="https://raw.githubusercontent.com/ruxo-rod/logos/main/logo%20IA.jpg"
              alt="InnovaAgent"
              className="h-8 w-8 rounded-lg"
            />
            <span>InnovaAgent</span>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <div className="flex items-center gap-3 mb-8 pb-6 border-b">
            <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
              <Shield className="w-5 h-5 text-green-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Aviso de Privacidad</h1>
              <p className="text-sm text-gray-500">InnovaAgent · innovagent.tech</p>
            </div>
          </div>

          <PrivacyContent />

          <div className="mt-8 pt-6 border-t text-center">
            <p className="text-sm text-gray-500">
              Para ejercer tus derechos ARCO escríbenos a{' '}
              <a
                href="mailto:contacto@bdctech.com.mx"
                className="text-blue-600 hover:underline"
              >
                contacto@bdctech.com.mx
              </a>
            </p>
            <p className="text-xs text-gray-400 mt-2">
              Consulta también nuestros{' '}
              <Link to="/terms" className="text-blue-500 hover:underline">
                Términos y Condiciones
              </Link>
            </p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default PrivacyPage
